export enum ActionType {
  API_DETAILS_BY_PID = "API_DETAILS_BY_PID",
  RESET_REDUX_STATE = "RESET_REDUX_STATE",
}

export interface IKSMProjectDetailsByPid {
  type: ActionType.API_DETAILS_BY_PID;
  payload: any;
}
export interface IResetReduxState {
  type: ActionType.RESET_REDUX_STATE;
}
export type Action = IKSMProjectDetailsByPid | IResetReduxState;
